import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import useCardView from '../../../hooks/useCardView';
import { useTheme } from '../../../hooks/useTheme';

const DesktopDynamicBanner = ({
	Title,
	SubtitleOne: Description,
	SubtitleTwo: TextLink,
	AltText = '',
	linkUrl,
	ImageUrl,
	openTextLinkInNewTab,
	Zone,
}) => {
	const { isDealsPage } = useSelector((state) => state);

	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const { isGridView } = useCardView();

	const { background, title, description, link } = useTheme('middleBanner');

	return (
		<div
			className={classnames(
				'border border-solid border-gray-30 rounded-lg py-4 px-8 mx-1 w-full',
				background,
				{
					flex: ImageUrl,
					'text-center': !ImageUrl,
					'mb-2': isGridView,
					'mx-2 my-2': Zone === 'Middle',
					'lg:mx-0': CustomCategoriesEnabled,
				}
			)}>
			<div
				className={classnames({
					'w-2/3': ImageUrl,
					'w-full mx-auto': !ImageUrl,
					'flex flex-col justify-center': isDealsPage,
				})}
				style={{ maxWidth: '72ch' }}>
				<div className={`text-display pb-2 ${title}`}>{Title}</div>
				<div className={`text-body-sm pb-2 ${description}`}>{Description}</div>
				{linkUrl ? (
					<a
						data-testid="text-link"
						className={`text-body font-bold ${link}`}
						href={linkUrl}
						onClick={openTextLinkInNewTab}>
						{TextLink}
					</a>
				) : (
					<span className={`text-body-sm ${link}`}>{TextLink}</span>
				)}
			</div>
			{ImageUrl && (
				<div className="w-1/3 flex items-center">
					{linkUrl ? (
						<a
							data-testid="image-link"
							className="mx-auto font-bold"
							href={linkUrl}
							onClick={openTextLinkInNewTab}>
							<img style={{ height: '150px' }} alt={AltText} src={ImageUrl} />
						</a>
					) : (
						<img style={{ height: '150px' }} alt={AltText} src={ImageUrl} />
					)}
				</div>
			)}
		</div>
	);
};

export default DesktopDynamicBanner;
